<template>
  <div>
    <div>
      <div class="g-card" style="margin-bottom: 20px">
        <div class="scrm-intro">
          <div class="flex item-center">
            <div class="title">会员标签</div>
            <div class="subTitle">
              <a
                href="https://doc.weixin.qq.com/doc/w3_ABcAHAZjANgRPnOj0UlR8S0oJ1ZKk?scode=APgAlAcrAAgagYWT7N"
                target="_blank"
                ><span class="hmicon icon-dingdan"></span>功能介绍</a
              >
            </div>
          </div>
          <div class="content mt10">
            客户标签提供灵活的标签管理能力、强大的打标能力、丰富的营销玩法应用，帮助商家更好的标记客户特征，丰富客户画像，做好客户分层和精准营销。
          </div>
        </div>
      </div>
      <el-row :gutter="20" style="min-height: 400px">
        <el-col :span="6" :xs="24">
          <div class="left-content">
            <div class="top-wrap">
            <el-button type="primary" @click="addType" style="width: 100%">
              新增分类
            </el-button>
            <div class="mt10 mb10 flex">
              <el-input
                v-model.trim="searchConditions.queryKeywords"
                placeholder="请输入分类或标签名称"
                class="flex-1"
              />
              <el-button
                type="primary"
                @click="searchType"
                size="mini"
                class="ml10"
              >
                查询
              </el-button>
            </div></div>
            <!-- default-expand-all -->
            <el-tree
              class="pdx20"
              ref="tree"
              :data="tagAttributeList"
              :props="defaultProps"
              :expand-on-click-node="true"
              :highlight-current="true"
              current-node-key="currentNode"
              node-key="id"
              :load="loadAttributeNode"
              lazy
              @node-click="handleNodeClick"
              :default-expanded-keys="defaultExpandedKeys"
            >
              <template v-slot="{ node, data }">
                <div
                  class="tree-label flex flex-end"
                  :class="{ system: data.categoryType === 'System' }"
                >
                  <div class="content-wrap">
                    <span
                      class="hmicon icon-xitongshezhi2x system-icon"
                      v-if="data.categoryType === 'System'"
                    ></span>
                    <hm-svg v-else :iconClass="data.categoryIcon||''" />
                    <span slot="title" v-html="heightlight(node.label)"></span>
                  </div>
                  <img
                    v-if="data.ruleType"
                    class="tag"
                    :src="
                      data.ruleType == 'multiColumns'
                        ? require('@/assets/multiColumns.png')
                        : data.ruleType == 'static'
                        ? require('@/assets/static.png')
                        : require('@/assets/dynamics.png')
                    "
                    alt=""
                  />
                  <el-dropdown
                    class="dropdown"
                    @command="onGroupCommand($event, node)"
                    v-if="data.categoryType === 'tenant'"
                    :hide-timeout="1500"
                  >
                    <span class="dot">
                      <i class="el-icon-more content-icon"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="groupEdit"
                        >修改分组</el-dropdown-item
                      >
                      <!-- <el-dropdown-item command="groupRemove">删除分组</el-dropdown-item> -->
                    </el-dropdown-menu>
                  </el-dropdown>
                  <!-- <div
                    class="iconfontScrm icon-icon-edit ml20"
                    v-if="data.categoryType === 'tenant'"
                    @click="editType(node)"
                  ></div> -->
                </div>
              </template>
            </el-tree>
          </div>
        </el-col>
        <el-col :span="18">
          <div class="g-card marginleft0" style="background: #fff; padding: 20px; box-size: border-box;border-radius: 4px;">
            <el-button
              type="primary"
              @click="addTag('static')"
              class="mr20"
              v-if="!isBtn('static:true')"
            >
              新建静态标签组
            </el-button>
            <el-button
              type="primary"
              @click="addTag('dynamics')"
              class="mr20"
              v-if="!isBtn('dynamics:true')"
            >
              新建动态标签组
            </el-button>
            <el-button
              type="primary"
              @click="addTag('multiColumns')"
              class="mr20"
              v-if="!isBtn('multiColumns:true')"
            >
              新建多字段标签
            </el-button>
          </div>
          <div class="g-card marginleft0" v-if="currentRow && currentRow.id" style="background: #fff; padding: 20px; box-size: border-box;border-radius: 4px; margin-top: 20px;">
            <div class="flex flex-between item-center right-content">
              <div class="right-title flex-1 mr20">
                {{ currentRow.tagName }}<span class="tips">生效</span>
              </div>
              <div class="">
                <!-- <el-button class="button-new-tag mr20">查看</el-button>
                <el-button class="button-new-tag mr20">复制</el-button> -->
                <!-- <el-button class="button-new-tag mr20">删除</el-button> -->
                <el-button
                  class="button-new-tag mr20"
                  type="primary"
                  plain
                  @click="pushQywechat(currentRow)"
                  :disabled="currentRow.wecomTagGroupId !== null"
                  v-if="
                    currentRow.ruleType === 'static' &&
                      currentRow.wecomTagMappingMode === 'yes' &&
                      currentRow.wecomTagGroupId
                  "
                  >已同步企业微信</el-button
                >
                <el-button
                  class="button-new-tag mr20"
                  type="primary"
                  plain
                  @click="pushQywechat(currentRow)"
                  v-else-if="
                    currentRow.ruleType === 'static' &&
                      currentRow.wecomTagMappingMode === 'yes' &&
                      !currentRow.wecomTagGroupId
                  "
                  >同步企业微信</el-button
                >
                <el-button
                  class="button-new-tag mr20"
                  type="primary"
                  @click="editTagDetail(currentRow)"
                  >编辑</el-button
                >
              </div>
            </div>
            <div class="flex mt20">
              <div class="mr20">
                <span class="gray">打标签方式：</span>
                <span v-if="currentRow.ruleType === 'static'">手动打标签</span>
                <span v-else-if="currentRow.ruleType === 'dynamics'"
                  >自动打标签</span
                >
              </div>
              <div class="ml20">
                <span class="gray">最近一次更新时间：</span
                >{{ currentRow.updateTime }}
              </div>
            </div>
          </div>
          <div
            class="g-card marginleft0"
            style="padding: 20px; box-size: border-box;border-radius: 4px; background: #fff; margin-top: 20px;"
            v-if="currentRow && currentRow.id && tagList && tagList.length"
          >
            <div>标签分布</div>
            <div class="progress-list">
              <div
                class="progress-item flex item-center"
                v-for="(item, index) in tagList"
                :key="index"
              >
                <div class="title">
                  {{ item.frontViewName }}
                  <el-popover
                    trigger="hover"
                    :content="item.dataDesc"
                    placement="top-start"
                    v-if="item.dataDesc"
                  >
                    <i slot="reference" class="el-icon-warning-outline"></i>
                  </el-popover>
                </div>
                <el-progress
                  :text-inside="true"
                  :show-text="false"
                  :stroke-width="20"
                  :percentage="item.doc_count_percent"
                  :color="item.dataColor"
                  class="progress"
                ></el-progress>
                <div class="num mr20">人数:{{ item.doc_count }}</div>
                <el-button
                  type="primary"
                  @click="tagOperateRunTagDataCalc(item)"
                  size="mini"
                  v-if="currentRow.ruleType !== 'static'"
                  >更新</el-button
                >
                <el-button
                  type="primary"
                  @click="exportTagDataCsv(item)"
                  size="mini"
                  >导出</el-button
                >
                <el-button
                  type="primary"
                  @click="tagOperatePushToWeComTagUser(item)"
                  size="mini"
                  v-if="
                    currentRow.ruleType === 'static' &&
                      currentRow.wecomTagMappingMode === 'yes' &&
                      parseInt(item.doc_count) > 0
                  "
                  >同步企业微信</el-button
                >
                <el-button
                  type="primary"
                  @click="extractTagDataTask(item)"
                  size="mini"
                  v-if="
                    currentRow.ruleType === 'dynamics' &&
                      item.dataRunningMode === 'extract'
                  "
                  >处理标签</el-button
                >
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-dialog
        :title="(ruleForm.id ? '修改' : '添加') + '分类'"
        :with-header="false"
        :wrapperClosable="false"
        class="create-tag-drawer"
        :visible.sync="categoryNameVisble"
        :append-to-body="true"
        width="600px"
      >
        <el-form
          label-width="120px"
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          @submit.native.prevent
        >
          <el-form-item label="分类名称" prop="categoryName">
            <el-input
              v-model.trim="ruleForm.categoryName"
              placeholder="请输入分类名称"
              class="flex-1"
              clearable
              maxlength="20"
              show-word-limit
            />
          </el-form-item>
          <el-form-item label="图标名称" prop="categoryIcon">
            <!-- <el-input
              v-model.trim="ruleForm.categoryIcon"
              placeholder="请输入图标名称"
              class="flex-1"
              clearable
            /> -->
            <el-select 
              ref="iconSelect"
              style="visibility: hidden"
              v-model.trim="ruleForm.categoryIcon"
              placeholder="请选择"
            >
              <el-option
                v-for="item in iconfontList"
                :key="item.font_class"
                :label="item.label"
                :value="item.font_class">
                <hm-svg :iconClass="item.font_class" />
              </el-option>
            </el-select>
            <div @click="handleSelectIcon" class="select-div">
              <hm-svg :iconClass="ruleForm.categoryIcon" />
            </div>
          </el-form-item>
          <el-form-item label="分类排序" prop="sortNum">
            <el-input
              v-model.trim="ruleForm.sortNum"
              placeholder="请输入分类排序"
              class="flex-1"
              clearable
              maxlength="6"
              show-word-limit
            />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="hideAddType">取 消</el-button>
          <el-button type="primary" @click="addTypeSubmit('ruleForm')"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>

    <el-dialog
      title='导出会员名单'
      :visible.sync='exportTypeDialog'
      width='630px'
      :close-on-click-modal='false'
      :close-on-press-escape='false'
      destroy-on-close
      custom-class='common-dialog'
    >
      <div class="radio-wrap">
        <span class="radio-title mr10">导出类型：</span>
        <el-radio-group v-model="exportType" @change="exportTableCheckList=[]">
          <el-radio label="base">基础类型（主要导出会员手机号）</el-radio>
          <el-radio label="zdy">自定义类型</el-radio>
        </el-radio-group>
      </div>
      <div class="zdy-wrap" v-if="exportType==='zdy'">
        <div class="_title">导出表头选择</div>
        <el-checkbox-group v-model="exportTableCheckList">
          <el-checkbox :label="item.columnName" v-for="item in exportTypeList" :key="item.id">{{item.labelName}}</el-checkbox>
        </el-checkbox-group>
      </div>
      <template slot='footer'>
        <el-button @click='exportTypeDialog = false' size='small'>取消</el-button>
        <el-button @click='handleConfirmExport' type='primary' size='small'>确定导出</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import XLSX from "xlsx";
import axios from "axios";
import { getCookie } from "@/utils/utils";
export default {
  components: {},
  data() {
    return {
      tagAttributeList: [],
      defaultProps: {
        label: "categoryName",
        isLeaf: (data, node) => {
          if (node.level === 1) {
            if (data.tagNum && data.tagNum > 0) {
              return false;
            } else {
              return true;
            }
          }
          if (node.level === 2) {
            return true;
          }
        }
      },
      searchConditions: {
        queryKeywords: ""
      },
      ruleForm: {
        id: "",
        categoryName: "",
        categoryIcon: "",
        sortNum: ""
      },
      rules: {
        categoryName: [{ required: true, message: "必填项", trigger: "blur" }]
      },
      currentPage: 1,
      pageSize: 10,
      categoryNameVisble: false,
      currentRow: {},
      node: {},
      tagList: [],
      defaultExpandedKeys: [],
      resolveFunc: function() {},
      isFirst: true,
      pushQywechatState: false,
      iconfontList: [],
      exportTypeDialog: false,
      exportType: "base",
      exportTableCheckList: [],
      exportRow: null,
      exportTypeList: []
    };
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
    const iconfontList =
      getCookie({ key: "iconfontList", type: "session" }) || [];
    this.iconfontList = iconfontList;
  },
  methods: {
    queryExportTagField() {
      this.$store.dispatch('queryExportTagField', {
        "templateCode" : "exportTagDataList"
      }).then(res => {
          console.log('---queryExportTagField---', res);
        if (res.code === '0') {
          // this.exportTableCheckList = res.data
          this.exportTypeList = res.result
        }
      })
    },
    searchType() {
      this.reloadTree();
    },
    handleNodeClick(data) {
      console.log(data.ruleType);
      this.isFirst = false;
      if (data.categoryType === "tagDetail") {
        this.currentRow = data;
        console.log("this.currentRow:", this.currentRow);
        this.queryTagById(data.ruleType).then(res => {
          this.queryTagCount();
        });
      }

    },
    addType() {
      this.ruleForm.id = "";
      this.categoryNameVisble = true;
    },
    editGroup(row) {
      console.log("row.data:", row.data);
      console.log("categoryType:", row.data.categoryType);
      if (row.data.categoryType === "tenant") {
        this.ruleForm.categoryName = row.data.categoryName;
        console.log("this.ruleForm.categoryName:", this.ruleForm.categoryName);
        this.ruleForm.categoryIcon = row.data.categoryIcon;
        this.ruleForm.sortNum = row.data.sortNum;
        this.ruleForm.id = row.data.id;
        this.categoryNameVisble = true;
      }
    },
    editTagDetail(row) {
      console.log("row:", row);
      this.$router.push({
        name: "MemberTagAdd",
        query: {
          ruleType: row.ruleType,
          id: row.id
        }
      });
    },
    async pushQywechat(row) {
      console.log(row);
      // return;
      const { code, result } = await this.$store.dispatch(
        "tagOperatePushToWeComGroupTag",
        {
          id: this.currentRow.id
        }
      );
      if (code === "0") {
        this.currentRow.wecomTagGroupId = "同步";
        console.log(
          "this.currentRow.wecomTagGroupId:",
          this.currentRow.wecomTagGroupId
        );
      }
    },
    addTypeSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const params = {
            categoryType: "tenant",
            parentId: 1,
            level: 1
          };
          const ruleForm = JSON.parse(JSON.stringify(this.ruleForm));
          Object.assign(params, ruleForm);
          let url = "tagCategoryInfoAdd";
          if (this.ruleForm.id) {
            Object.assign(params, { id: this.ruleForm.id });
            url = "tagCategoryInfoEdit";
          }
          this.$store.dispatch(url, params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
            }
            this.categoryNameVisble = false;
            this.reloadTree();
            // this.$router.go(0)
          });
        }
      });
    },
    hideAddType() {
      this.categoryNameVisble = false;
    },
    addTag(ruleType) {
      this.$router.push({
        name: "MemberTagAdd",
        query: {
          ruleType
        }
      });
    },
    reloadTree() {
      this.node.childNodes = [];
      this.loadAttributeNode(this.node, this.resolveFunc);
    },
    loadAttributeNode(node, resolve) {
      // 一级节点处理
      if (node.level === 0) {
        this.node = node;
        this.resolveFunc = resolve;
        this.requestAttributeTree(resolve);
      }
      // 其余节点处理
      if (node.level >= 1) {
        // 注意！把resolve传到你自己的异步中去
        this.getAttributeIndex(node, resolve);
      }
    },
    // 首次加载属性数
    requestAttributeTree(resolve) {
      this.$store
        .dispatch("tagCategoryInfoQueryPageList", {
          parentId: 1,
          level: 1,
          queryKeywords: this.searchConditions.queryKeywords,
          pageNo: 1,
          pageSize: 9999
        })
        .then(res => {
          let data = res.result.records;
          data = data.sort(this.sortBy("sortNum"));
          data.forEach(v => {
            v.attrId = v.id;
            v.attrValue = v.categoryName;
            v.disabled = true;
          });
          if (this.isFirst) {
            this.defaultExpandedKeys = [data[0].id];
          }
          resolve(data);
        })
        .catch(err => {
          throw new Error(err);
        });
    },
    getAttributeIndex(node, resolve) {
      if (node.level > 1) return resolve([]);
      this.$store
        .dispatch("tagBasicInfoQueryTagListByCategoryId", {
          tagCategoryId: node.data.attrId
        })
        .then(res => {
          const data = res.result;
          data.forEach(v => {
            v.attrId = v.tagCategoryId;
            v.categoryType = "tagDetail";
            v.categoryName = v.tagName;
            v.disabled = true;
            v.leaf = true;
          });
          if (this.isFirst && data) {
            this.handleNodeClick(data[0]);
          }
          resolve(data);
        })
        .catch(err => {
          throw new Error(err);
        });
    },
    async queryTagById(type) {
      let url = "queryTagBasicInfoAndDataRangeConfigListByTagBasicId";
      if(type === "multiColumns"){
        url = "queryTagBasicInfoAndDataColumnConfigListByTagBasicId";
      }
      this.tagList = [];
      const { result } = await this.$store.dispatch(
        url,
        {
          id: this.currentRow.id
        }
      );
      // console.log("result22222222:", result);
      if (result) {
        if (result.tagDataRangeConfigList ||result.tagDataColumnConfigList ) {
          this.tagList = result.tagDataRangeConfigList;
          if(type == "multiColumns"){
            this.tagList = result.tagDataColumnConfigList;
          }
          console.log(555)
          console.log(this.tagList);
          this.tagList.forEach(v => {
            v.doc_count = 0;
            v.doc_count_percent = 0;
          });
        }
      }
    },
    async queryTagCount() {
      const { result } = await this.$store.dispatch(
        "staticTagOperateGetTagDataCount",
        {
          id: this.currentRow.id
        }
      );
      if (result) {
        this.tagListCount = result;
        let countAll = 0;
        this.tagList.forEach(v => {
          this.tagListCount.forEach(o => {
            if (v.id === o.key.tagDataId) {
              v.doc_count = o.doc_count;
              countAll += v.doc_count;
            }
          });
        });
        console.log("countAll:", countAll);
        this.tagList.forEach(v => {
          if (v.doc_count && v.doc_count != "未配置") {
            v.doc_count_percent =
              (parseFloat(v.doc_count) / parseFloat(countAll)).toFixed(2) * 100;
          }
        });
        this.tagList = JSON.parse(JSON.stringify(this.tagList));
        this.tagList = this.tagList.sort(this.sortBy("sortNum"));
        console.log("this.tagList:", this.tagList);
      }
    },
    sortBy(field) {
      //根据传过来的字段进行排序,y-x 得分从高到低，x-y 从低到高
      return (x, y) => {
        return x[field] - y[field];
      };
    },
    async extractTagDataTask(row) {
      this.$message({
        message: "处理标签中...",
        type: "info"
      });
      const { code, errMsg } = await this.$store.dispatch(
        "extractTagDataTask",
        {
          tagDataId: row.id
        }
      );
      if (code === "0") {
        this.$message({
          message: errMsg,
          type: "success"
        });
      }
    },
    async tagOperateRunTagDataCalc(row) {
      const { code, result } = await this.$store.dispatch(
        "tagOperateRunTagDataCalc",
        {
          tagDataId: row.id
        }
      );
      if (code === "0") {
        if (result) {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          console.log("result:", result);
          this.queryTagById().then(res => {
            this.queryTagCount();
          });
        }
      }
    },
    async tagOperatePushToWeComTagUser(row) {
      if (parseInt(row.doc_count) > 0) {
        const { code, result } = await this.$store.dispatch(
          "tagOperatePushToWeComTagUser",
          {
            tagDataId: row.id
          }
        );
        if (code === "0") {
          this.$message({
            message: "操作成功",
            type: "success"
          });
        }
      }
    },
    async exportTagDataCsv(row) {
      this.exportRow = row
      this.exportTypeDialog = true

      // const { code, result } = await this.$store.dispatch("exportTagDataCsv", {
      //   tagDataId: row.id,
      //   obtainResultMode: "sync"
      // });
      // if (code === "0") {
      //   if (result) {
      //     this.save(result);
      //   }
      // }
    },
    async handleConfirmExport() {
      if(this.exportType==='zdy') {
        if(this.exportTableCheckList.length < 1) {
          return this.$message.warning("请至少选择一个导出表头")
        }
        const { code, result } = await this.$store.dispatch("exportTagDataCsvCustom", {
          "tagDataId": this.exportRow.id,
          "obtainResultMode": "sync",
          "exportFieldList" : this.exportTableCheckList
        });
        if (code === "0") {
          if (result) {
            this.save(result);
          }
        }
      } else {
        const { code, result } = await this.$store.dispatch("exportTagDataCsv", {
          tagDataId: this.exportRow.id,
          obtainResultMode: "sync"
        });
        if (code === "0") {
          if (result) {
            this.save(result);
          }
        }
      }
    },
    save(row) {
      axios({
        method: "post",
        url: this.$serverAdress + `/sys/common/download?filePath=${row.path}`,
        responseType: "arraybuffer"
      }).then(res => {
        this.download(res.data, row.name);
        this.exportTypeDialog = false;
      });
    },
    download(data, name) {
      if (!data) {
        return;
      }
      console.log("data:", data);
      let blob = new Blob([data], { type: "application/octet-stream" });
      let url = window.URL.createObjectURL(blob);
      console.log("url:", url);
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url); //释放掉blob对象
    },
    heightlight(text) {
      var reg = new RegExp(this.searchConditions.queryKeywords, "gi");
      text = text.replace(reg, function(txt) {
        return `<span class="heightlight">` + txt + `</span>`;
      });
      return text;
    },
    isBtn(code) {
      // console.log("this.code::::", code);
      // console.log(this.isShowBtn(code))
      return this.isShowBtn(code);
    },
    onGroupCommand(e, node) {
      if (node.id === "1") {
        this.msgInfo("默认分组不可操作！");
        return;
      }
      if (e == "groupEdit") {
        this.editGroup(node);
      }
      // else if (e == 'groupRemove') {
      //   this.removeGroup(node.id)
      // }
    },
    handleSelectIcon() {
      this.$refs.iconSelect.toggleMenu();
    },
  }
};
</script>
<style lang="scss" scoped>
.scrm-intro {
  background-color: #ffffff;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 4px;
}
.left-content {
  min-height: 70vh;
  border-radius: 4px;
  padding-bottom: 20px;
  background: #ffffff;
  border-radius: var(--border-radius-big);
}
.top-wrap {
  padding: 20px 20px 0;
}
.pdx20 {
  padding: 0 20px;
}
.relative {
  position: relative;
}
.margin20 {
  margin: 20px;
}
.marginleft0 {
  margin-left: 0;
}
.right-content {
  border-bottom: solid 1px #e9eef7;
  padding-bottom: 15px;
}
.right-title {
  font-size: 18px;
  color: #222222;
  line-height: 28px;
  .tips {
    color: #00a870;
    background: #e8f8f2;
    padding: 5px 10px;
    margin-left: 20px;
    border-radius: 4px;
  }
}
.gray {
  color: #999999;
}
.progress-list {
  .progress-item {
    margin-top: 20px;
    .title {
      min-width: 70px;
      text-align: right;
      display: inline-block;
      margin-right: 20px;
    }
    .progress {
      width: 500px;
      margin-right: 20px;
    }
    .num {
      display: inline-block;
      min-width: 130px;
    }
  }
}
/deep/ span.heightlight {
  color: var(--color) !important;
}
/deep/ .el-tree {
  max-height: 680px;
  overflow-y: auto;
}
/deep/ .el-tree-node {
  position: relative;
}
/deep/ .el-tree-node__content {
  height: 40px;
  padding-right: 48px;
  position: relative;
  .tag {
    width: 40px;
    height: 40px;
    position: absolute;
    top: 0;
    right: 0;
  }
}
/deep/ .tree-label {
  flex: 1;
  overflow: hidden;
  justify-content: flex-start;
  .content-wrap {
    overflow-x: auto;
  }
}
.dropdown {
  position: absolute;
  right: 0;
  top: 12px;
}
.content-icon {
  transform: rotate(90deg);
}

.select-div {
  position: absolute;
  top: 0;
  width: 220px;
  height: 40px;
  padding: 0 10px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  box-sizing: border-box;
}

.radio-wrap {
  .radio-title {
    font-size: 14px;
    color: #222222;
  }
}
.zdy-wrap {
  margin-top: 20px;
  ._title {
    margin-bottom: 10px;
    position: relative;
    padding-left: 10px;
    font-weight: 500;
    font-size: 14px;
    color: #222222;
    &::before {
      content: "";
      width: 3px;
      height: 16px;
      background: #3180FF;
      border-radius: 8px 8px 8px 8px;
      position: absolute;
      left: 0;
    }
  }
  .el-checkbox {
    margin-bottom: 6px;
  }
}
</style>
